// TODO: BEZ BEZ BEZ END
import moment from 'moment'
import { graph } from '@adc/constants'
import { helpers } from '@adc/core-utils'
import { constants } from '@adc/ui-adc'
import { get, capitalize, toLower } from 'lodash'
import {
  getMarketingAttribute,
  getShowableContentAttribute,
} from '../common/utils/graph'

const stateList = constants.optionLists.states
const states = {}
stateList.forEach(state => {
  states[state.value] = state.text
})

// This is for getPriceAreaMaxBid
const MAX_BID_VALUE_NOT_AVAILABLE = 'Not Disclosed'
const VALUE_COMING_SOON = 'Coming Soon'

// NOTE: Fight the urge to rewrite right now. We map here, which then maps to
// something else in design system, which _then_ shows up in the app. Once
// repiped we can remove all this mapping and code directly against the enums. (TODO)
const DEED_TYPE_MAPPING = {
  [graph.enums.ListingDeedType.WARRANTY_DEED]: 'Warranty Deed or equivalent',
  [graph.enums.ListingDeedType.SPECIAL_WARRANTY_DEED]:
    'Special Warranty Deed or equivalent',
  [graph.enums.ListingDeedType.QUITCLAIM_DEED]: 'Quitclaim Deed or equivalent',
  [graph.enums.ListingDeedType.QD_ASSIGNMENT_INTEREST]:
    "Quitclaim Deed and Assignment of Interest in Sheriff's Deed",
  [graph.enums.ListingDeedType.QD_ASSIGNMENT_CERT]:
    "Quitclaim Deed and Assignment of Sheriff's Cert",
  [graph.enums.ListingDeedType.TRUSTEE_DEED]: "Trustee's Deed",
  [graph.enums.ListingDeedType.RELEASE_DEED]: 'Release Deed or Equivalent',
}

const foreclosureFAQUrl = 'https://www.auction.com/lp/foreclosure/'

const getPartyByRole = (listing, role) =>
  get(listing, 'parties', []).find(elem => elem.party_role === role) || {}

const capitalizeSnakeCase = (value = '') =>
  value ? value.split('_').map(capitalize).join(' ') : ''

// const ARV_COMING_SOON = 'Coming Soon'
const ARV_NOT_AVAILABLE = 'Not Available'

const getARV = listing => {
  const ARValue = get(listing, 'primary_property.summary.valuation')

  // service does not currently supply information pertaining to if it's "coming soon", so for now we either show
  // value if is sent, or show "Not Available" if value is not sent.

  return !ARValue ? ARV_NOT_AVAILABLE : String(ARValue)
}

const getImages = listing =>
  get(listing, 'photos', []).map(photo => {
    photo.regular_url = photo.file_descriptor.urls.cdn
    return photo
  })

const getDocuments = listing => {
  const listingDocuments = get(listing, 'documents', []).map(doc => ({
    display_label: doc.document_external_title,
    regular_url:
      doc.file_descriptor.urls.cdn || doc.file_descriptor.urls.download,
    doc_type: doc.metadata.document_purpose_type_code,
    modified_date: doc.updated_date,
  }))

  // NOTE: Sort by `GlobalMediaPriorityLevel` here if we change the pdp documents section to show differently with
  // multiple documents of the same code listed. Right now the logic is to always just grab the first one which we don't
  // want to change because it matches non-repipe.
  const globalDocuments = get(listing, 'applicable_global_documents', []).map(
    doc => ({
      display_label: doc.media_external_title,
      regular_url: doc.media_download_uri,
      doc_type: doc.media_purpose_type_code,
      modified_date: doc.updated_date,
    })
  )

  return globalDocuments.concat(listingDocuments)
}

const getREOAddress = listing => {
  const summary = get(listing, 'primary_property.summary', {})
  const address = summary.address || {}
  return {
    complete_address: summary.formatted_address,
    street_name: summary.street_address,
    city: address.municipality,
    county: address.country_secondary_subdivision,
    state: states[address.country_primary_subdivision],
    state_code: address.country_primary_subdivision,
    postal_code: address.postal_code,
    latitude: get(address, 'coordinates.lat', 0),
    longitude: get(address, 'coordinates.lon', 0),
  }
}

/*
 * https://git.infra.aucn.io/projects/RA/repos/resi-pal/browse/src/server/endpoints/trustee-assets/v1/trustee_assets.transformers.js#564,570
 * This is to match the priceArea.max_bid logic on resi pal for graph
 * It's important to keep these string values and leave the existing structure as it is until we change BiddingStatus model
 * event though we have this logic in the graph already.
 * https://git.infra.aucn.io/projects/RA/repos/resi-toolkit-adc/browse/src/models/biddingStatus/index.js#592
 */
const getPriceAreaMaxBid = (displayReserveValue, reserveValue) => {
  if (displayReserveValue) {
    return reserveValue ? parseFloat(reserveValue) : VALUE_COMING_SOON
  } else {
    return MAX_BID_VALUE_NOT_AVAILABLE
  }
}

export const listingToTPSProperty = (listing, req) => {
  // this was commented out
  const auctionDetails = {
    online_event: get(listing, 'venue.venue_type', '') === 'ONLINE',
  }

  // Only the status that are being used right now
  const auctionDayStatusMapping = {
    NO_SALE: '6',
    CLOSED: '18',
    SALE_GATEKEEPING: '4',
    SALE_PAYMENT_PENDING: '7',
  }
  // till here
  const wireCompanyContact = getPartyByRole(listing, 'TITLE_COMPANY_CONTACT')
  const wireCompany = getPartyByRole(listing, 'TITLE_COMPANY')
  //  It's a business decision to prioritize TITLE_COMPANY party_address over TITLE_COMPANY_CONTACT party_address the order it's important here
  const wireAddress =
    wireCompany?.party_address || wireCompanyContact?.party_address || {}

  const closingCompany = {
    //  It's a business decision to prioritize TITLE_COMPANY party_name over TITLE_COMPANY_CONTACT party_name
    closing_company_alt_contact:
      wireCompany.party_name || wireCompanyContact.party_name,
    closing_company_alt_phone: wireCompanyContact.party_phone
      ? wireCompanyContact.party_phone
      : wireCompany.party_phone,
    closing_company_alt_email: wireCompanyContact.party_email
      ? wireCompanyContact.party_email
      : wireCompany.party_email,
    closing_company_address: wireAddress.street_description,
    closing_company_city: wireAddress.municipality,
    closing_company_state: wireAddress.country_primary_subdivision,
    closing_company_alt_zip: wireAddress.postal_code,
  }

  const eventCode = get(listing, 'event.event_code', '')
  // this was commented out
  const auction = {
    auction_id: get(listing, 'event.event_id', ''),
    event_id: get(listing, 'event.event_id', ''),
    auction_number: eventCode,
    venue_code: get(listing, 'venue.venue_code', ''),
    venue_type: get(listing, 'venue.venue_type', ''),
    auction_date: get(listing, 'auction.auction_date', ''),
    auction_start_date: get(listing, 'auction.auction_date', ''),
    is_auctioneer_assigned:
      get(listing, 'listing_configuration.trustee_sales_channel') ===
      'AUCTIONEERING',
    auction_details: auctionDetails,
    auction_day_status:
      auctionDayStatusMapping[get(listing, 'listing_status', '')],
  }

  const fullPropertyAddress = get(
    listing,
    'primary_property.summary.formatted_address',
    ''
  )

  const REOAddress = getREOAddress(listing)

  const address = {
    property_address: REOAddress.street_name,
    property_city: REOAddress.city,
    property_county: REOAddress.county,
    property_state: REOAddress.state,
    property_zip: REOAddress.postal_code,
    latitude: REOAddress.latitude,
    longitude: REOAddress.longitude,
  }

  const { show: displayTrusteeSaleNo, label: trusteeSaleNoAltText } =
    getMarketingAttribute(
      listing,
      graph.enums.MarketingAttributeType.TRUSTEE_SALE_NUMBER
    )

  const propertyType = capitalizeSnakeCase(
    listing.primary_property?.summary?.structure_type_code
  )

  const propertyDetail = {
    property_morpheus_id: get(listing, 'primary_property_id'),
    product_type_original: get(
      listing,
      'listing_configuration.product_type',
      ''
    ),
    provisional_sale_date: get(listing, 'auction.provisional_sale_date'),
    pdp_url: `${req.protocol}://${req.hostname}/details${get(
      listing,
      'listing_page_path',
      ''
    )}`,
    year_built: get(listing, 'primary_property.summary.year_built', ''),
    mls_comment: get(listing, 'listing_remarks.mls_comment', ''),
    special_notes: get(listing, 'listing_remarks.special_notes', ''),
    property_type: propertyType,
    property_state_code: REOAddress.state_code,
    status_label: listing.listing_status_label,
    sale_deposit_amt: get(listing, 'trustee.online_state_deposit_amount', 0),
    ...address,
    ...closingCompany,
    property_trustee_details: {
      trustee_reference_id: get(listing, 'trustee_reference_id', ''),
      trustee_sale_number: get(listing, 'trustee_sale_number', ''),
      display_trustee_sale_no: displayTrusteeSaleNo,
      trustee_sale_no_alt_text: trusteeSaleNoAltText,
      apn: get(listing, 'primary_property.summary.apn', ''),
    },
    seller_code: get(listing, 'seller_plan.seller_plan_code'),
  }

  const { message: msgForChecks } = getMarketingAttribute(
    listing,
    graph.enums.MarketingAttributeType.DEPOSIT_CHECK_VERBIAGE
  )

  const { message } = getMarketingAttribute(
    listing,
    graph.enums.MarketingAttributeType.SALES_AGENT_CONTACT
  )

  const partnershipDetails =
    get(listing, 'trustee.partnership_details', '') || message

  const finance = {
    msg_for_checks: msgForChecks,
  }

  const productDetails = {
    bedrooms: get(listing, 'primary_property.summary.total_bedrooms', ''),
    bathrooms: get(listing, 'primary_property.summary.total_bathrooms', ''),
    lot_size: get(listing, 'primary_property.summary.lot_size', ''),
    square_footage: get(listing, 'primary_property.summary.living_size', ''),
    event_item: eventCode,
    occupancy_status: get(
      listing,
      'listing_configuration.occupancy_status',
      ''
    ),
    postponement_date: get(
      listing,
      'listing_configuration.postponement_new_auction_date'
    ),
    postponement_time: get(
      listing,
      'listing_configuration.postponement_new_auction_time'
    ),
  }

  const priceArea = {
    opening_bid: get(listing, 'auction.starting_bid', 0),
    max_bid: getPriceAreaMaxBid(
      get(listing, 'listing_configuration.is_reserve_displayed', false),
      get(listing, 'reserve_price', null)
    ),
    est_debt: parseInt(
      get(listing, 'auction.bid_instruction.nos_amount', 0),
      10
    ),
    after_repair_value: getARV(listing),
    original_balance: get(
      listing,
      'listing_configuration.principal_original_amount',
      0
    ),
  }

  const venueStreetUnit = get(listing, 'venue.venue_address.street_unit') || ''
  const venueStreetNumber =
    get(listing, 'venue.venue_address.street_number') || ''
  const venueStreetName = get(listing, 'venue.venue_address.street_name') || ''
  const venueStreetAddress = `${venueStreetNumber} ${venueStreetName} ${venueStreetUnit}`
  const venueCity = get(listing, 'venue.venue_address.municipality') || ''
  const venueState =
    get(listing, 'venue.venue_address.country_primary_subdivision') || ''
  const venueZip = get(listing, 'venue.venue_address.postal_code') || ''

  const eventDetailsQueryString = helpers.queryCollectionFormatter({
    venueID: listing.venue?.venue_id,
    venueByDate: moment(
      get(listing, 'venue.venue_schedule.bid_start_local_date', '')
    ).format('YYYY-MM-DD'),
    state: get(
      listing,
      'primary_property.summary.address.country_primary_subdivision',
      ''
    ),
    county: get(
      listing,
      'primary_property.summary.address.country_secondary_subdivision',
      ''
    ),
  })

  const eventDetailsUrl = `/event/details/${eventCode}?${eventDetailsQueryString}`
  const saleTime = get(listing, 'trustee.sale_time')

  const eventDetails = {
    venue_name: get(listing, 'venue.venue_name', ''),
    venue_address: `${venueStreetAddress}, ${venueCity}, ${venueState} ${venueZip}`,
    venue_url: get(listing, 'venue.venue_url', ''),
    sale_time: saleTime ? moment(saleTime, 'HH:mm:ss').format('hh:mm a') : '',
    event_details_url: eventDetailsUrl,
  }

  const images = getImages(listing)

  const documents = getDocuments(listing)

  const productTypeOriginal = propertyDetail.product_type_original || ''
  const venueType = auction.venue_type || ''
  // @TODO: Circle back with Malika to make sure that this logic is still relevant
  const isAdcEvent = auction.is_auctioneer_assigned
  // Don't add any more usage of this function, there is similar on in resi-fe-dashboard and we don't wanna use that anymore.
  const isTpsOnline =
    productTypeOriginal.toLowerCase() === 'trustee' &&
    venueType.toLowerCase() === 'online' &&
    isAdcEvent

  const additionalContacts = {
    foreclosure_faq_url: `${foreclosureFAQUrl}${toLower(
      REOAddress.state_code
    )}${isTpsOnline ? '/?faq=online' : ''}`,
    partnership_details: partnershipDetails,
    appraiser_link: null,
    clerk_of_court_link: null,
  }

  const disclaimer = {
    disclaimer_map: {
      cms_body: getMarketingAttribute(
        listing,
        graph.enums.MarketingAttributeType.DISCLAIMER
      ).message,
    },
  }

  return {
    auction,
    status: propertyDetail.status_label,
    property_detail: propertyDetail,
    product_details: productDetails,
    event_details: eventDetails,
    price_area: priceArea,
    additional_contacts: additionalContacts,
    finance,
    document: { sortedDocs: documents, images: { documents: images } },
    address: { full_property_address: fullPropertyAddress },
    is_tps_online: isTpsOnline,
    disclaimer,
    property_return: {},
  }
}

export const listingToREOProperty = (listing, req) => {
  const address = getREOAddress(listing)
  const propertyType = capitalizeSnakeCase(
    listing.primary_property?.summary?.structure_type_code
  )

  const productType = get(listing, 'listing_configuration.product_type', '')

  const propertyDetails = {
    property_morpheus_id: get(listing, 'primary_property_id'),
    product_type_original: productType,
    pdp_url: `${req.protocol}://${req.hostname}/details${get(
      listing,
      'listing_page_path',
      ''
    )}`,
    year_built: get(listing, 'primary_property.summary.year_built', ''),
    mls_comment: get(listing, 'listing_remarks.mls_comment', ''),
    special_notes: get(listing, 'listing_remarks.special_notes', ''),
    status_label: listing.listing_status_label,
    property_type: propertyType,
    after_repair_value: getARV(listing),
    total_bedrooms: get(listing, 'primary_property.summary.total_bedrooms', ''),
    hoa_dues: get(listing, 'listing_configuration.monthly_hoa_amount'),
    total_bathrooms: get(
      listing,
      'primary_property.summary.total_bathrooms',
      ''
    ),
    exterior_acerage: get(listing, 'primary_property.summary.lot_size', ''),
    interior_square_footage: get(
      listing,
      'primary_property.summary.living_size',
      ''
    ),
    occupancy_status: get(
      listing,
      'listing_configuration.occupancy_status',
      ''
    ),
    address,
    seller_code: get(listing, 'seller_plan.seller_plan_code'),
    seller_deed_type: (listing.program_configuration?.deed_types || [])
      .map(type => DEED_TYPE_MAPPING[type])
      .filter(Boolean)
      .join(','),
  }

  const eventCode = get(listing, 'event.event_code', '')

  const productTypeMap = {
    RENTALS: 'Rental',
    SHORT_SALE: 'Short Sale',
    REO: 'Bank Owned',
  }

  const brokerInfo = getPartyByRole(
    listing,
    graph.enums.ListingPartyRole.BROKER
  )

  const listingAgentInfo = getPartyByRole(
    listing,
    graph.enums.ListingPartyRole.LISTING_AGENT
  )

  const agentInfo = [
    {
      brokerage_name: brokerInfo.party_name,
      agent_name: listingAgentInfo.party_name,
      brokerage_phone: brokerInfo.party_phone
        ? brokerInfo.party_phone
        : listingAgentInfo.party_phone,
      brokerage_email: brokerInfo.party_email
        ? brokerInfo.party_email
        : listingAgentInfo.party_email,
    },
  ]

  const transactionDetails = {
    event_item: eventCode,
    online_event: get(listing, 'venue.venue_type', '') === 'ONLINE',
    auction_number: eventCode,
    is_coming_soon: listing.is_coming_soon,
    is_proxy: listing.listing_configuration.is_proxy_bidding_enabled,
    is_financing_available: get(
      listing,
      'listing_configuration.financing_available',
      false
    ),
    auction_date: get(listing, 'auction.auction_date', ''),
    auction_time: get(listing, 'venue.venue_schedule.initial_bidding_end_time'),
    auction_id: get(listing, 'event.event_id', ''),
    event_id: get(listing, 'event.event_id', ''),
    agent_info: agentInfo,
    transaction_cms_information: getMarketingAttribute(
      listing,
      graph.enums.MarketingAttributeType.TRANSACTION_DETAILS
    ).message,
    auctioneer_info: getShowableContentAttribute(
      listing,
      graph.enums.MarketingAttributeType.AUCTIONEER_LICENSING
    ),
    venue: {
      ...get(listing, 'venue'),
      venue_address: get(listing, 'venue.venue_location_directions'),
    },
    product_type: productTypeMap[productType],
    product_type_original: productType,
    is_reserve_displayed: Boolean(
      listing.listing_configuration?.is_reserve_displayed
    ),
  }

  const images = getImages(listing)

  const documents = getDocuments(listing)

  const disclaimer = {
    disclaimer_map: {
      cms_body: getMarketingAttribute(
        listing,
        graph.enums.MarketingAttributeType.DISCLAIMER
      ).message,
    },
  }

  return {
    images,
    documents,
    property_details: propertyDetails,
    transaction_details: transactionDetails,
    additional_details: {},
    disclaimer,
    property_return: {},
  }
}
